import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../lib/cn.js";
const toneClasses = {
    success: "bg-status-success/15 text-status-success",
    warning: "bg-status-warning/15 text-status-warning",
    critical: "bg-status-critical/15 text-status-critical",
    overtime: "bg-status-overtime/20 text-status-overtime",
    offline: "bg-status-offline/15 text-status-offline",
    neutral: "bg-fg-tertiary/15 text-fg-secondary",
    brand: "bg-brand-primary/15 text-brand-primary",
};
const badgeVariants = cva("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-caption font-medium leading-none h-6");
export function StatusBadge({ tone, icon, className, children, ...props }) {
    return (_jsxs("span", { className: cn(badgeVariants(), toneClasses[tone], className), ...props, children: [icon ? (_jsx("span", { className: "[&_svg]:size-3.5", "aria-hidden": "true", children: icon })) : null, _jsx("span", { children: children })] }));
}
//# sourceMappingURL=status-badge.js.map